export const FUNDING_SPACE_ID = '5a0zbg81idj6'

export enum CONTENT_BLOCK_LAYOUT {
  BIO = 'bio',
  CARD = 'card',
  PERKS = 'perks',
  TESTIMONIAL = 'testimonial',
}
